
import { contactImages } from '../../../utils/images';

export default function GlobalSupport() {
  const locations = [
    {
      title: "New York Sales Team",
      role: "North American Market",
      description: "Dedicated sales and customer service for US and Canadian clients",
      features: [
        "Local market expertise and trend analysis",
        "Direct client communication and support",
        "Trade show representation and networking",
        "Logistics coordination for North America"
      ],
      image: contactImages.ny
    },
    {
      title: "China Manufacturing Base",
      role: "Production Excellence",
      description: "State-of-the-art manufacturing facilities with skilled craftsmen",
      features: [
        "100,000 m² production facility",
        "300+ skilled workers and technicians",
        "Advanced machinery and quality control",
        "Sustainable manufacturing practices"
      ],
      image: contactImages.china
    }
  ];

  return (
    <section className="py-20 bg-white pb-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Global Support Network
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our international presence ensures seamless service delivery and local expertise for clients worldwide
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {locations.map((location, index) => (
            <div key={index} className="bg-gray-50 p-6 border border-gray-200 flex-1">
              <div className="mb-4">
                <img
                  src={location.image}
                  alt={location.title}
                  className="w-full h-48 object-cover object-top mb-4"
                />
                <div className="flex items-center mb-2">
                  <i className="ri-map-pin-line text-lg text-blue-600 mr-2"></i>
                  <h3 className="text-lg font-bold text-gray-900">{location.title}</h3>
                </div>
                <p className="text-blue-600 font-semibold text-sm mb-2">{location.role}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">{location.description}</p>
              </div>

              <ul className="space-y-2">
                {location.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-green-600 text-sm mr-2 mt-0.5"></i>
                    <span className="text-gray-700 text-xs leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
